module.exports = __webpack_public_path__ + "media/images/roku/link-image-e914d0fc92c787e8a21d54cae73c40d8.png";